var map = {
	"./audio.svg": 7942,
	"./code.svg": 5967,
	"./default.svg": 7399,
	"./email.svg": 7272,
	"./excel.svg": 4505,
	"./image.svg": 6551,
	"./link.svg": 672,
	"./pdf.svg": 698,
	"./powerpoint.svg": 9871,
	"./video.svg": 6321,
	"./word.svg": 8320,
	"./zipper.svg": 9450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2530;